export default {
  "hierarchy": {
    "small": [
      "compositeTextInput-small"
    ],
    "search": [
      "compositeTextInput-search"
    ],
    "mobileSearch": [
      "compositeTextInput-search",
      "compositeTextInput-mobileSearch"
    ],
    "password": [
      "compositeTextInput-formInput",
      "compositeTextInput-password"
    ],
    "scan": [
      "compositeTextInput-scan"
    ],
    "pairSearch": [
      "compositeTextInput-fullWidth",
      "compositeTextInput-pairSearch"
    ],
    "fullWidth": [
      "compositeTextInput-fullWidth"
    ],
    "formInput": [
      "compositeTextInput-formInput"
    ],
    "attributeSelectorFilter": [
      "compositeTextInput-search",
      "compositeTextInput-mobileSearch",
      "compositeTextInput-attributeSelectorFilter"
    ],
    "formSearchBar": [
      "compositeTextInput-formSearchBar"
    ],
    "attributeTableUnitEditor": [
      "compositeTextInput-attributeTableUnitEditor"
    ],
    "attributeDetailUnitEditor": [
      "compositeTextInput-attributeDetailUnitEditor"
    ],
    "attributeStringEditor": [
      "compositeTextInput-attributeStringEditor"
    ],
    "attributeFormEditor": [
      "compositeTextInput-attributeFormEditor"
    ],
    "salesFlowCustomerLookup": [
      "compositeTextInput-salesFlowCustomerLookup"
    ]
  },
  "props": {
    "default": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "small": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "search": {
      "iconOpts": {
        "style": {
          "color": "#67798E",
          "fontSize": "16px"
        }
      },
      "button": "Search",
      "icon": "@icon:search"
    },
    "mobileSearch": {
      "iconOpts": {
        "style": {
          "color": "#67798E",
          "fontSize": "16px"
        }
      },
      "button": "",
      "icon": "@icon:search"
    },
    "password": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "scan": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "pairSearch": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "fullWidth": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "formInput": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "attributeSelectorFilter": {
      "iconOpts": {
        "style": {
          "fontSize": "",
          "padding": ""
        }
      },
      "button": null,
      "icon": "@icon:search"
    },
    "formSearchBar": {
      "iconOpts": {
        "style": {
          "background": "",
          "fontSize": "20px",
          "padding": "8px"
        }
      },
      "icon": "@icon:search"
    },
    "attributeTableUnitEditor": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "attributeDetailUnitEditor": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "attributeStringEditor": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "attributeFormEditor": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    },
    "salesFlowCustomerLookup": {
      "iconOpts": {
        "style": {
          "padding": ""
        }
      }
    }
  }
}